export type BBox = {
  x: number
  y: number
  width: number
  height: number
}

const MAX_SIZE = 800

/**
 * 画像URLからbbox領域を切り出したCanvasを返す
 */
export const cropBBoxToCanvas = async (
  imageUrl: string,
  bbox: BBox,
): Promise<HTMLCanvasElement> => {
  if (bbox.width <= 0 || bbox.height <= 0) {
    throw new Error('BBox width and height must be positive')
  }

  const img = new Image()
  img.crossOrigin = 'anonymous'

  return new Promise((resolve, reject) => {
    img.onload = () => {
      // bbox領域のピクセル座標を計算
      const srcX = Math.floor(bbox.x * img.width)
      const srcY = Math.floor(bbox.y * img.height)
      const srcW = Math.max(1, Math.floor(bbox.width * img.width))
      const srcH = Math.max(1, Math.floor(bbox.height * img.height))

      // 長辺がMAX_SIZEになるようにスケール
      const longestSide = Math.max(srcW, srcH)
      const scale = MAX_SIZE / longestSide

      const destW = Math.max(1, Math.floor(srcW * scale))
      const destH = Math.max(1, Math.floor(srcH * scale))

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        reject(new Error('Failed to get canvas context'))
        return
      }

      canvas.width = destW
      canvas.height = destH
      ctx.drawImage(img, srcX, srcY, srcW, srcH, 0, 0, destW, destH)

      resolve(canvas)
    }

    img.onerror = () => reject(new Error('Failed to load image'))
    img.src = imageUrl
  })
}
